import './HHotelToBooking.scss';

import * as tsx from 'vue-tsx-support';
import { PropType, VNode } from 'vue';
import { getCustomBookingActionSetting, toInfo } from './utils';
import { HHotelToBookingAction } from './HHotelToBookingAction';
import { HHotelToBookingAir } from './HHotelToBookingAir';
import { HHotelPriceInfo } from '~/components';
import {
  HotelBasicInfo,
  HotelDetail,
  HotelBrandBasicInfo,
  BookingActionSetting,
} from '~/schemes';
import {
  mergeVNodeData,
  resolveTourListLinkOptions,
  withTourListCampaign,
  TourListLinkOptions,
  TOUR_LIST_CAMPAIGNS,
} from '~/helpers';

export const HHotelToBooking = tsx.component({
  name: 'HHotelToBooking',
  functional: true,

  props: {
    hotel: Object as PropType<HotelBasicInfo | HotelDetail | undefined>,
    brand: Object as PropType<HotelBrandBasicInfo | undefined>,
    eventId: String,
    /** TourList への送客計測用のリンク設定 */
    tourList: Object as PropType<TourListLinkOptions | undefined>,
  },

  render(h, { data, props, parent }): VNode {
    const { brand, hotel, eventId, tourList } = props;

    const { hasLowestPrice, hasBookingLink, dynamicPackage } = toInfo(
      parent,
      props,
    );

    const bookingActionSetting: BookingActionSetting | null =
      parent.$store.getters['bookingActionSettings/current'];

    const customSettings = getCustomBookingActionSetting(bookingActionSetting);

    const { air } = dynamicPackage;

    const hideBookingLink = !!hotel && hotel.hideBookingLink;

    return (
      <div
        {...mergeVNodeData(data, {
          staticClass: 'h-hotel-to-booking',
          directives: [
            {
              name: 'show',
              value: hasLowestPrice || hasBookingLink,
            },
          ],
        })}>
        {/* @comment リリース後ブランドサイトの金額を非表示にしたい場合はhotelを条件式に追加 */}
        {hasLowestPrice && !customSettings.customUrl && (
          <HHotelPriceInfo
            staticClass="h-hotel-to-booking__price"
            brandSlug={brand && brand.slug}
          />
        )}
        {!hideBookingLink && (
          <HHotelToBookingAction
            staticClass="h-hotel-to-booking__action"
            hotel={hotel}
            brand={brand}
            customSettings={customSettings}
            eventId={eventId}
            tourList={tourList}
          />
        )}
        {!!air && !customSettings.customUrl && (
          <HHotelToBookingAir
            staticClass="h-hotel-to-booking__air"
            // attrs で渡すと、HBtn 側で変換した href を親の attrs が上書きするため props で渡す
            props={{
              href: air,
              tourList: withTourListCampaign(
                tourList || resolveTourListLinkOptions(parent),
                TOUR_LIST_CAMPAIGNS.air,
              ),
            }}
          />
        )}
      </div>
    );
  },
});
